import { render, staticRenderFns } from "./UmsApplicationStateSwitcher.vue?vue&type=template&id=1a48f55e&"
import script from "./UmsApplicationStateSwitcher.vue?vue&type=script&lang=js&"
export * from "./UmsApplicationStateSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports